import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const DELETE_ENTRY_TRANSLATION = questionnaireGql(/* GraphQL */ `
  mutation deleteEntryTranslationV2(
    $input: DeleteEntryTranslationV2ArgsInput!
  ) {
    deleteEntryTranslationV2(input: $input) {
      ...DraftQuestionnaireEntry
    }
  }
`)
